module.exports = "/img/user-guided-tours/customers-list/customize@2x.png?fb25ea75afce8e9e06e7cbe4068894d1";